exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".video-play-paused-styling.video-js button.vjs-mute-control.vjs-control.vjs-button{max-height:4em !important}.video-play-paused-styling.vjs-playing button.vjs-big-play-button{display:none !important}.video-play-paused-styling.vjs-paused button.vjs-big-play-button{display:block !important}\n", ""]);

